import React from "react";
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'PIN Code',
      attr: 'pincode',
      disableSort: true
    },
    {
      label: 'Area',
      attr: 'area',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'City',
      attr: 'city',
      disableSort: true
    },
    {
      label: 'District',
      value: row => row.district.name,
      disableSort: true
    },
    {
      label: 'State',
      value: row => row?.state?.name,
      disableSort: true
    },
    {
      label: 'Updated At',
      attr: 'updated_at',
      disableSort: true
    }
  ]

  return <>
    <ListingComponent
      key={'PAGES.PincodesTabListingPage.name'}
      listingMutation={getApi('serviceCenterOperationalPincodes')}
      recordsKey="pincodes"
      className="pincodes-listing-page"
      contentHeading="Operational Pincodes - Results"
      headers={headers}
      params={props.defaultParams}
      searchBy={['PIN Code', 'City']}
    />
  </>
};

export default Listing;
